module.exports = __webpack_public_path__ + "static/media/arrow_right.eb34ca0e.svg";